import { alpha } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(theme => ({
  form: { display: "flex", flexDirection: "column", alignItems: "center", width: "100%" },
  iconCircle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    borderRadius: "50%",
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.primary.dark,
    fontSize: 24,
    marginBottom: theme.spacing(2.5),
  },
  title: { fontWeight: 700, fontSize: 24, color: theme.palette.grey[800], marginBottom: theme.spacing(1) },
  description: { fontSize: 14, color: theme.palette.grey[600], lineHeight: 1.5, maxWidth: 400 },
  digitsRow: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(3.5),
    marginBottom: theme.spacing(1),
  },
  digitInput: { width: 56, [theme.breakpoints.down("sm")]: { width: 44 } },
  digitInputBase: { textAlign: "center", fontSize: 24, fontWeight: 700 },
  hint: { fontSize: 12, color: theme.palette.grey[500], minHeight: theme.spacing(2.5) },
  errorMessage: { fontSize: 13, fontWeight: 600, color: theme.palette.error.darker, minHeight: theme.spacing(2.5) },
  submitButton: { width: "100%", maxWidth: 360, marginTop: theme.spacing(3.25), marginBottom: theme.spacing(2) },
  resendLink: { display: "block", marginBottom: 0 },
  securityNotice: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    textAlign: "left",
    marginTop: theme.spacing(3.5),
    width: "100%",
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.neutral,
    color: theme.palette.grey[500],
  },
  securityNoticeText: { fontSize: 12, color: theme.palette.grey[600], lineHeight: 1.45 },
}));
